import { OrganizationIdsGuard } from '@/features/authentication/_components/OrganizationIdsGuard';
import type { FC } from 'react';
import { Route, Routes } from 'react-router';
import NotFoundPage from './pages/NotFoundPage';
import WorkflowListPage from './pages/WorkflowListPage';
import WorkflowTemplateListPage from './pages/WorkflowTemplateListPage';

export const WorkflowRoutes: FC = () => {
  return (
    <OrganizationIdsGuard showDenied>
      <Routes>
        <Route index element={<WorkflowListPage />} />
        <Route path="template" element={<WorkflowTemplateListPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </OrganizationIdsGuard>
  );
};
